// import hooks
import { useTranslation } from "react-i18next";
import { useState, useRef } from "react";

// import components
import Modal from "react-bootstrap/Modal";
import ReCAPTCHA from "react-google-recaptcha";

// import assets
import "../../assets/css/modals.css";
import { oceanLogo } from "../../utils/images";
import { whiteCart } from "../../utils/cards-svgs";

// import PhoneInput from "react-phone-input-2";
// import "react-phone-input-2/lib/style.css";
// import ar from "react-phone-input-2/lang/ar.json";

import CustomPhoneInput from "../UI/CustomPhoneInput";

const { REACT_APP_RECAPTCHA_SITE_KEY } = process.env;

const SignupModal = (props) => {
    const [t] = useTranslation("global");
    const [phone, setPhone] = useState();
    // console.log(`siteekey: ${REACT_APP_RECAPTCHA_SITE_KEY}`)
    // console.log("----------------------")
    const captchaRef = useRef(null);

    const handleSubmit = (e) => {
        e.preventDefault();
        // const token = captchaRef.current.getValue();
        // console.log(token)
        captchaRef.current.reset();
        props.mode.openVerify();
    };
    const openLogin = () => {
        props.mode.openLogin();
    };

    const changePhone = (e) => {
        setPhone(e);
    };
    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            className={`signup-modal custom-modal ${props.lang} ${props.view} ${props.mode.mode}`}
        >
            <Modal.Body>
                <div className="modal-cls-container">
                    <div
                        className="closeSvg"
                        onClick={() => props.mode.cls(false)}
                    ></div>
                </div>
                <div className="custom-modal-head">
                    <img
                        src={oceanLogo}
                        alt="logo"
                        className="custom-modal-img"
                    />
                    <h2 className="custom-modal-h">
                        {t("modals.signup.head")}
                    </h2>
                    <p className="custom-modal-p">{t("modals.signup.txt")}</p>
                </div>
                <div className="custom-modal-body">
                    <form
                        className="custom-modal-form signup-form"
                        onSubmit={(e) => handleSubmit(e)}
                    >
                        <div className="label-input-div sign-up-form-field">
                            <label className="custom-modal-label">
                                {t("modals.signup.name")}
                            </label>
                            <input
                                type="text"
                                className="custom-modal-input"
                                placeholder={t("modals.signup.name")}
                            />
                        </div>

                        {/* <div className="label-input-div">
                            <label className="custom-modal-label">
                                {t("modals.signup.phone")}
                            </label>

                            <PhoneInput
                                country={"sa"}
                                value={phone}
                                preferredCountries={[
                                    "sa",
                                    "om",
                                    "qa",
                                    "ae",
                                    "kw"
                                ]}
                                regions={["middle-east", "north-africa"]}
                                localization={props.lang == "ar" && ar}
                                onChange={(e) => setPhone(e)}
                                excludeCountries={["il"]}
                                enableAreaCodes={false}
                            />
                        </div> */}
                        <CustomPhoneInput
                            phone={phone}
                            onHandleChange={changePhone}
                        />

                        <div className="label-input-div sign-up-form-field">
                            <label className="custom-modal-label">
                                {t("modals.signup.email")}
                            </label>
                            <input
                                type="text"
                                className="custom-modal-input"
                                placeholder={t("modals.signup.email")}
                            />
                        </div>

                        <p className="custom-modal-error login-error">
                            Error field
                        </p>
                        <div className="recaptcha-div">
                            <ReCAPTCHA
                                sitekey={REACT_APP_RECAPTCHA_SITE_KEY}
                                ref={captchaRef}
                                theme={props.mode.mode}
                            />
                        </div>

                        <button type="submit" className="custom-modal-btn">
                            <img src={whiteCart} alt="icon" />
                            <span>{t("modals.signup.btn")}</span>
                        </button>
                    </form>
                </div>
                <div className="custom-modal-footer">
                    <p>
                        <span>{t("modals.signup.txt2")}</span>{" "}
                        <span className="custom-modal-link" onClick={openLogin}>
                            {t("modals.signup.link")}
                        </span>
                    </p>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default SignupModal;
